import Controller from 'controllers/controller';
import Binder from 'tools/binder';
import Helpers from 'tools/helpers';
import ObjectFit from 'tools/object-fit';

class ObjectFitController extends Controller {
    constructor(app) {
        super(app);
        
        this.binder = new Binder(this);
        this.objectFit = new ObjectFit({
            attachEvents: false
        });
        
        this.attachEvents();
    }
    
    attachEvents() {
        this.app.loaderController.on('page-loaded', Helpers.delayedFunction(400, this.binder.bind('onPageLoaded')));
        window.addEventListener('resize', Helpers.delayedFunction(400, this.binder.bind('onWindowResize')));
    }
    
    onPageLoaded() {
        this.objectFit.setElements();
        this.objectFit.onResize();
    }

    onWindowResize() {
        this.objectFit.setElements();
        this.objectFit.onResize();
    }
}

export default ObjectFitController;